import * as Yup from "yup";

const phoneRegExp = /^(\d)(?!\1+$)\d{9}$/;

export const fwaSchema = (t) => {
    return Yup.object().shape({
        dealerEmail: Yup.string().email(t("Email Invalid")),
        orderNumber: Yup.string().when("purchaseDeviceLocation", {
            is: (val) =>
                ["Purchased in store, received via shipping", "Shipped directly from TELUS"].includes(val),
            then: (schema) => schema.required(t("Order Number Required")),
            otherwise: (schema) => schema.notRequired()
        }),
        businessName: Yup.string().required(t(`Business Name Required`)),
        streetNumber: Yup.string().required("Street Number Required"),
        streetName: Yup.string().required("Street Name Required"),
        unitNumber: Yup.string(),
        city: Yup.string().required("City Required"),
        province: Yup.string()
            .required(t("Province Required"))
            .test(
                "is-within-province",
                "Address should be in Alberta or British Columbia provinces",
                function (value) {
                    if (!value) return false;
                    return ["alberta", "british columbia"].includes(value.toLowerCase());
                }
            ),
        postalCode: Yup.string().required("Postal Code Required"),
        smartHubForBusinessProduct: Yup.string().required("This is a required field"),
        smarthubAtMoreThanOneLocation: Yup.string().required("This is a required field"),
        email: Yup.string().email(t("Email Invalid")).required(t("Email Required")),
        accountNumber: Yup.string()
            .required("Account Number Required")
            .min(8, "Account Number must be 8 digits")
            .max(8, "Account Number no more than 8 digits"),
        subscriberNumber: Yup.string()
            .required(t("Subscriber Number Required"))
            .min(14, "Subscriber Number must be 10 digits")
            .max(14, "Subscriber Number no more than 10 digits")
            .test("is-subscriber-number", t("Subscriber Number Must be 10 Digits"), (value) => {
                const number = value && value.replace(/[-() _]/g, "");
                return phoneRegExp.test(number);
            }),
        purchaseDeviceLocation: Yup.string().required(
            t("Purchase Device Location Required")
        ),
        onsiteContactName: Yup.string().required(t("Contact Name Required")),
        onsiteContactNumber: Yup.string()
            .required(t("Contact Number Required"))
            .min(14, "Contact Number must be 10 digits")
            .max(14, "Contact Number no more than 10 digits")
            .test("is-contact-number", t("Contact Number Invalid"), (value) => {
                const number = value && value.replace(/[-() _]/g, "");
                return phoneRegExp.test(number);
            }),
        businessHours: Yup.string().required(t("Business Hours Required")),
        buildingType: Yup.string().required(t("Building Type Required")),
        buildingPermission: Yup.string().required(t("Building Permission Required")),
        appointmentDate: Yup.string().required(t("Appointment Date Required")),
        preferredDate1: Yup.string().when("appointmentDate", {
            is: (appointmentDate) => appointmentDate === "Preferred Dates",
            then: (schema) => schema.required(t("Date Required")),
            otherwise: (schema) => schema.notRequired()
        }),
        preferredDate2: Yup.string().when("appointmentDate", {
            is: (appointmentDate) => appointmentDate === "Preferred Dates",
            then: (schema) => schema.required(t("Date Required")),
            otherwise: (schema) => schema.notRequired()
        }),
        installFeeAcknowledgment: Yup.boolean()
            .oneOf([true], t("INSTALL_FEE_ACKNOWLEDGMENT_REQUIRED")),
        additionalInfo: Yup.string()
    });
};